import { Link } from "react-router-dom";
import { CONTACT, DESTINATIONS } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-white">
      <div className="mx-auto max-w-[1600px] px-6 py-20 lg:px-12 lg:py-28">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src="/assets/logo-white.png" alt="Urban Trail" className="h-8 w-auto" />
            <p className="mt-8 max-w-xs font-serif text-2xl font-light leading-snug text-white/85">
              Thoughtfully curated journeys. Beautifully experienced.
            </p>
            <div className="mt-10 space-y-3 text-sm text-white/60">
              <p>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="transition-colors hover:text-gold">
                  {CONTACT.email}
                </a>
              </p>
              <p>
                <a href={CONTACT.phoneHref} data-testid="footer-phone" className="transition-colors hover:text-gold">
                  {CONTACT.phone}
                </a>
              </p>
              <p className="max-w-xs leading-relaxed">{CONTACT.office}</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-12 sm:grid-cols-4 lg:col-span-8">
            <div>
              <p className="label text-white/40">Explore</p>
              <ul className="mt-6 space-y-3.5 text-sm">
                {[["Home", "/"], ["About", "/about"], ["Destinations", "/destinations"], ["Journal", "/journal"]].map(([l, to]) => (
                  <li key={l}>
                    <Link to={to} data-testid={`footer-explore-${l.toLowerCase()}`} className="text-white/70 transition-colors hover:text-gold">
                      {l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="label text-white/40">Company</p>
              <ul className="mt-6 space-y-3.5 text-sm">
                {[["Careers", "/careers"], ["Contact", "/contact"]].map(([l, to]) => (
                  <li key={l}>
                    <Link to={to} data-testid={`footer-company-${l.toLowerCase()}`} className="text-white/70 transition-colors hover:text-gold">
                      {l}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="label text-white/40">Destinations</p>
              <ul className="mt-6 space-y-3.5 text-sm">
                {DESTINATIONS.map((d) => (
                  <li key={d.slug}>
                    <Link
                      to={`/destinations/${d.slug}`}
                      data-testid={`footer-destination-${d.slug}`}
                      className="text-white/70 transition-colors hover:text-gold"
                    >
                      {d.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="label text-white/40">Connect</p>
              {CONTACT.socials.length > 0 ? (
                <ul className="mt-6 space-y-3.5 text-sm">
                  {CONTACT.socials.map((s) => (
                    <li key={s.name}>
                      <a
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`footer-social-${s.name.toLowerCase()}`}
                        className="text-white/70 transition-colors hover:text-gold"
                      >
                        {s.name}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <ul className="mt-6 space-y-3.5 text-sm text-white/70">
                  <li data-testid="footer-social-instagram">Instagram</li>
                  <li data-testid="footer-social-facebook">Facebook</li>
                  <li data-testid="footer-social-linkedin">LinkedIn</li>
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="mt-20 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs tracking-[0.14em] text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Urban Trail Pvt. Ltd. All Rights Reserved.</p>
          <p className="flex flex-wrap gap-x-8 gap-y-3">
            <Link to="/privacy" data-testid="footer-privacy" className="transition-colors hover:text-gold">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms" className="transition-colors hover:text-gold">
              Terms &amp; Conditions
            </Link>
            <Link to="/cancellation-policy" data-testid="footer-cancellation" className="transition-colors hover:text-gold">
              Cancellation Policy
            </Link>
            <Link to="/refund-policy" data-testid="footer-refund" className="transition-colors hover:text-gold">
              Refund Policy
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
